import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  bottom: 0px;
  top: 0px;
  left: 0px;
  right: 0px;
  z-index: 999;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7); ;
`;

export const InstructionsWrapper = styled.div`
  background-color: white;
  width: 350px;
  height: 500px;
`;

export const Instructions = styled.img`
  object-fit: contain;
  width: 100%;
  height: 100%;
`;
